var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2168 0.207031H5.30383C2.77695 0.207031 0.728516 2.25547 0.728516 4.78235V12.433C0.728516 14.9599 2.77696 17.0083 5.30384 17.0083H12.9545C15.4814 17.0083 17.5298 14.9599 17.5298 12.433V12.4316H16.0298V12.433C16.0298 14.1314 14.6529 15.5083 12.9545 15.5083H5.30384C3.60538 15.5083 2.22852 14.1314 2.22852 12.433V4.78235C2.22852 3.0839 3.60538 1.70703 5.30383 1.70703H7.2168V0.207031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25977 0.957031H10.0851",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7793 12.4336L16.7793 8.60827",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4326 1.91406L15.8234 4.78305",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90149 9.55415L7.89826 9.62811C7.88583 9.91283 8.12364 10.1451 8.40799 10.1261L8.58686 10.114C10.1035 10.0122 11.5404 9.39729 12.6611 8.37033L16.7467 4.62656C17.6229 3.8237 17.6823 2.46259 16.8795 1.58643C16.0766 0.710269 14.7155 0.65084 13.8394 1.45369L10.0668 4.91059C8.75782 6.11006 7.97893 7.7804 7.90149 9.55415Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.59f9f0a368ec29ade4aa9c19e100eaff.svg";
export { ForwardRef as ReactComponent };